import React from 'react'
import SliderBasic from '../SliderBasic'
import filterMoviesToday from '../functions/filterMoviesToday'


const CustomSliderSelections = ({
    index, 
    attributeStyling, 
    setIdForActiveSelection, 
    currentActiveSelection, 
    mainSliderAdvertisementPositioning,
    selectionId, 
    itemSelection, 
    itemCollections, 
    features,
    translation, 
    hiddenAttributes,
    type,
    moviesRoutesData,
    ads, 
    movies, 
    ignoreAttributesForPerformanceFilter,
    showAvailableIn,
    elbenwald,
    informationStyling,
    detailsStyling,
    sliderAppearance,
    smallSliderAppearance,
    theme,
    sliderSettings, 
    nowObject,
    isConnectedFast
}) => {
    if(!itemSelection) {
        return ''
    }

    const { filterValue, title, filterType }  = itemSelection
    const backgroundVisualsSettings = {
        style: itemSelection.style,
        trailerAutoplay: features.has_trailer_views && itemSelection.trailerAutoplay
    }
    const collectionId = itemSelection.collections[0]
    const collectionItems = itemCollections[collectionId] && itemCollections[collectionId].items ? itemCollections[collectionId].items : []
    const classBasic = "slider-basic slider-basic-small " + selectionId
    const classEvenOdd = 0 === index%2 ? ' odd ' : ' even '
    const classParallax = theme === 'Arthouse' || collectionItems.length > 1 ? '' : ' can-parallax'
    const canParallax = theme === 'Arthouse' || collectionItems.length > 1 ? false : true
    const items = 'moviesToday' === filterValue || 'moviesTodayByStart' === filterValue ? filterMoviesToday(collectionItems, movies, nowObject, translation.timezone, filterValue) : collectionItems

    return <SliderBasic
        attributeStyling={attributeStyling}
        canParallax={canParallax}
        mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
        hiddenAttributes={hiddenAttributes}
        detailsStyling={detailsStyling}
        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
        settings = {sliderSettings}
        type={type}
        informationStyling= {informationStyling}
        sliderAppearance= {sliderAppearance}
        smallSliderAppearance= {smallSliderAppearance}
        features={features}
        items = {items}
        filterValue={filterValue}
        filterType={filterType}
        translation={translation}
        showAvailableIn={showAvailableIn}
        moviesRoutesData={moviesRoutesData}
        sliderTitle={title}
        backgroundVisualsSettings={backgroundVisualsSettings}
        moviesData = {movies}
        adsData = {ads}
        elbenwald={elbenwald}
        theme={theme}
        selectionId = {selectionId}
        scrollToPosition = {classBasic + classEvenOdd + classParallax}
        currentActiveSelection={currentActiveSelection}
        setIdForActiveSelection={setIdForActiveSelection}
        isConnectedFast={isConnectedFast}
        isFront={true}
        isMainSlider={false}
    />
}


export default CustomSliderSelections